import axiosRequest from 'axios'

import { DOCUMENT_API_URL } from '@/constants'

export const documentsInstance = axiosRequest.create({
  baseURL: `${DOCUMENT_API_URL}api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})
